<template lang="html">
  <div class="centerx">
    <input id='fileinputbr' type='file' accept='.csv' @change="readCSV($event, brandChipsFull)" style="display: none;" />
    <!--<vs-button @click="popupActivo4=true" color="danger" type="border">Open fullscreen popup</vs-button>-->
    <vs-popup
      :title="'Éditer les marques de ' + society.name"
      :active.sync="popupActive"
    >
      <div class="container" style="min-width: 800px;max-width: 1000px;">
        <!-- <div class="vx-row w-full"><div class="vx-col">Séparer chaque compétiteurs du séparateur suivant: "," .</div></div> -->
        <!-- <div class="vx-row w-full">
          <div class="vx-col">Ex: Rankwell, Rank well, Rank whale, ranque wèle...</div>
        </div> -->
        <div class="vx-row mt-4 w-full">
          <div class="vx-col"><vs-input class="inputx" placeholder="Nouvelle marque..." v-model="newBrand"/></div>
          <div class="vx-col"><vs-button @click="addBrand">Ajouter Marque</vs-button></div>
          <div class="vx-col"><vs-button @click="csvImport">Importer CSV</vs-button></div>
          <div class="vx-col">
            <vx-tooltip text='Importe la colonne "brand" du fichier CSV. Enregistrez le CSV sous le format "CSV Windows" avec "Enregistrer sous...".'>
                      <vs-avatar text="?" style="cursor: default;"></vs-avatar>
                    </vx-tooltip>
          </div>
          <div class="vx-col"><strong><vs-chip :color="chipState">{{ brandChipsFull.length }}/{{ brandLimit }}</vs-chip></strong></div>

        </div>
        <vs-divider />
        <div class="vx-row mt-2 w-full">
          <div class="vx-col pt-2"><span>Chercher une marque : </span></div>
          <div class="vx-col"><vs-input class="inputx" placeholder="Marque recherchée..." v-model="brandQuery" /></div>
          <div class="vx-col pt-2"><strong class="float-right">Nombre de marques affichées : {{ brandChips.length }}</strong></div>
        </div>
        <vs-divider />
        <div class="vx-row mt-4">
          <vs-chip @click="remove(brand)" :key="index" v-for="(brand,index) of brandChips" closable>{{ brand }}</vs-chip>
          <!-- <vs-textarea v-model="stringBrands" height="200px" rows="10" /> -->
        </div>
        <div class="vx-row float-right">
          <vs-button color="danger" type="filled" @click="closePopup"
            >Annuler</vs-button
          >
          <vs-button color="success" type="filled" @click="save" class="ml-2"
            >Sauvegarder</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
	name: "BrandEditorPopup",
	props: {
		society: Object,
		popupActive: Boolean,
		brands: Array,
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			stringBrands: null,
			brandChips: [],
			brandChipsFull: [],
			brandQuery: "",
			newBrand: "",
			brandLimit: 100,
			errorLimit: false,
			chipState: "success",
		};
	},
	created() {
		this.stringBrands = this.$props.brands.join(", ");
		this.brandChipsFull = this.$props.brands.map((brand) =>
			brand.toLowerCase()
		);
		this.brandChips = this.$props.brands.map((brand) => brand.toLowerCase());
	},
	watch: {
		brands: function (data) {
			this.stringBrands = data.join(", ");
			this.brandChipsFull = data.map((brand) => brand.toLowerCase());
			this.brandChips = data.map((brand) => brand.toLowerCase());
		},
		brandQuery: function (data) {
			this.brandChips = this.brandChipsFull.filter((chip) =>
				chip.includes(data.toLowerCase())
			);
		},
		brandChipsFull: function (data) {
			this.brandChips = data.filter((chip) =>
				chip.includes(this.brandQuery.toLowerCase())
			);
			this.checkBrandLimit();
		},
		/**
		 * When the props coming from parent changes, we update it
		 */
		/*
		 * society: {
		 *   immediate: true,
		 *   handler: function(newVal, oldVal) {
		 *     this.topkeywords = JSON.parse(newVal.topkeywords).join(",");
		 *   },
		 *   deep: true
		 * }
		 */
	},
	methods: {
		addBrand() {
			this.brandChipsFull.push(this.newBrand.toLowerCase());
			this.newBrand = "";
		},
		addBrands(brands) {
			for (let brand of brands) {
				//console.log(brand);
				if (this.brandChipsFull.includes(brand.toLowerCase()) == false) {
					this.brandChipsFull.push(brand.toLowerCase());
				}
			}
		},
		checkBrandLimit() {
			if (this.brandChipsFull.length > this.brandLimit) {
				this.chipState = "danger";
				this.errorLimit = true;
			} else {
				this.chipState = "success";
				this.errorLimit = false;
			}
		},
		csvImport() {
			//console.log("csvImport");
			let inputFile = document.getElementById("fileinputbr");
			//console.log(inputFile);
			inputFile.click();
		},
		readCSV(file, brands) {
			/*
			 * //console.log("file", file.target.result)
			 * //console.log("file", file.target.files[0])
			 */
			let reader = new FileReader();
			const callback = this.addBrands;
			reader.onload = function (e) {
				let mergedKeywords = [];
				let data = new Uint8Array(e.target.result);
				let workbook = XLSX.read(data, { type: "array" });
				/* DO SOMETHING WITH workbook HERE */
				let sheet_name_list = workbook.SheetNames;
				let fetched_brands = XLSX.utils.sheet_to_json(
					workbook.Sheets[sheet_name_list[0]],
					{ raw: true, defval: null }
				);
				//console.log("fetched_brands", fetched_brands);
				if (fetched_brands.length > 0) {
					mergedKeywords = [...brands];
					// //console.log("mergedKeywords", mergedKeywords)
					fetched_brands.forEach((row) => {
						if (row.brand && row.brand !== null) {
							// //console.log("brand", row.brand)
							if (!mergedKeywords.includes(row.brand))
								mergedKeywords.push(row.brand);
							// //console.log("mergedKeywords updated", mergedKeywords)
						}
					});
					/*
					 * //console.log(mergedKeywords)
					 * let stringMergedKeywords = mergedKeywords.join(',')
					 */
					callback(mergedKeywords);
				}
			};
			reader.readAsArrayBuffer(file.target.files[0]).result;
			/*
			 * //console.log("mergedKeywords updated 2", this.mergedKeywords) // REPLACE WITH A DISPLAY SHOWING NEWLY IMPORTED KEYWORDS AND VALIDATE
			 * this.onSaveTke(this.mergedKeywords)
			 */
		},
		save() {
			//console.log("this.errorLimit", this.errorLimit);
			if (this.errorLimit == false) {
				this.$emit("close-popup", false);
				this.$emit("updated-brands", this.brandChipsFull.join(","));
			}
		},
		remove(item) {
			this.brandChipsFull.splice(this.brandChipsFull.indexOf(item), 1);
			this.brandChips.splice(this.brandChips.indexOf(item), 1);
		},
		closePopup() {
			this.brandChipsFull = this.$props.brands;
			this.$emit("close-popup", false);
		},
	},
};
</script>
